import type { WaresToDepotFilters } from '@models/ware'
import { keyToUrl } from '@tools/common'
import { omit } from 'lodash'

export const waresKeys = {
  root: (orderId?: number) => ['wares', orderId ?? null] as const,
  ware: (id: number) => [waresKeys.root(), id] as const,
  waresToDepot: (filters?: WaresToDepotFilters) =>
    [
      'wares',
      'toDepot',
      omit(filters, ['page', 'limit']),
      { page: filters?.page, limit: filters?.limit },
    ] as const,
}

export const waresUrls = {
  root: keyToUrl(waresKeys.root()),
  ware: (id: number) => keyToUrl(waresKeys.ware(id)),
  waresToDepot: keyToUrl(waresKeys.waresToDepot()),
}
